import { HttpError } from './HttpError';

export class HttpForbidden extends HttpError {
    constructor(public OriginalError?: any, public FriendlyTitle?: string, public FriendlyMessage?: string) {
        super(OriginalError);
    }
}
